export default {
  computed: {
    disclaimers() {
      let isInCompareMode = this.$route.params.mode === 'compare'

      let cubeIds = [this.$store.state.query.mainCubeId]

      if (isInCompareMode) {
        cubeIds = cubeIds.concat([
          this.$store.state.query.pairCubeId,
          this.$store.state.query.sizeCubeId,
        ])
      }

      cubeIds = new Set(cubeIds.filter(v => v))

      let countryIds = this.$store.getters.mainAvailableCountries

      if (isInCompareMode) {
        countryIds = countryIds.concat(this.$store.getters.pairAvailableCountries)

        if (this.$store.getters.sizeCountryDimension) {
          countryIds = countryIds.concat(this.$store.getters.sizeAvailableCountries)
        }
      }

      countryIds = new Set(countryIds.filter(v => v))

      return this.$store.getters.disclaimer(cubeIds, countryIds)
    },
    exportSources() {
      return this.$store.state.external.exportSources.filter(
        el => el.key == this.$store.state.query.mainCubeId
      )
    },
  },
}
